import { z } from 'zod';

import { ContentfulDocumentSchema } from './contentful-document.validator';
import { ContentfulSysSchema } from './contentful-sys.validator';
import { CountryLocaleEntrySchema, LocalizedCountryLocaleEntrySchema } from './country-locale.validator';

export const FooterCountryInfoEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.string().optional().nullable(),
    title: z.string(),
    country: CountryLocaleEntrySchema,
    email: z.string(),
    phone: z.string(),
    address: ContentfulDocumentSchema,
    oleId: z.number().int().optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export const LocalizedFooterCountryInfoEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.record(z.string(), z.string().optional().nullable()).optional().nullable(),
    title: z.record(z.string(), z.string()),
    country: z.record(z.string(), LocalizedCountryLocaleEntrySchema),
    email: z.record(z.string(), z.string()),
    phone: z.record(z.string(), z.string()),
    address: z.record(z.string(), ContentfulDocumentSchema),
    oleId: z.record(z.string(), z.number().int().optional().nullable()).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
